(function () {
  'use strict';

  var WISHLIST_KEY = 'shopify_wishlist_ids';

  /* Shop money format and active currency are printed on each card by Liquid. */
  function moneyConfig() {
    var card = document.querySelector('[data-product-card][data-money-format]');
    return {
      format: card ? card.dataset.moneyFormat : '',
      currency: card ? card.dataset.currency : ''
    };
  }
  var variantPicker = null;
  var PCVP_OVERLAY_TOKEN = 'pcvp-variant-picker';
  var pcvpSharedOverlayLocked = false;
  var pcvpTouchY = null;
  var pcvpReturnFocus = null;
  var pickerState = {
    card: null,
    product: null,
    selected: [],
    variant: null,
    colorHandle: ''
  };

  function parseProduct(card, handle) {
    if (!card) return null;
    var wanted = String(handle || card.dataset.selectedProductHandle || card.dataset.productHandle || '');
    var nodes = Array.prototype.slice.call(card.querySelectorAll('[data-product-card-json]'));
    var node = nodes.find(function (item) {
      return String(item.getAttribute('data-product-handle') || '') === wanted;
    }) || nodes[0];
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch (e) { return null; }
  }

  function selectedProduct(card) {
    return parseProduct(card, card && card.dataset.selectedProductHandle);
  }

  function colorFamily(card) {
    if (!card) return [];
    return Array.prototype.slice.call(card.querySelectorAll('[data-swatch]')).map(function (swatch) {
      return {
        handle: swatch.getAttribute('data-product-handle') || '',
        productId: swatch.getAttribute('data-product-id') || '',
        url: swatch.getAttribute('data-product-url') || '',
        color: swatch.getAttribute('data-color') || '',
        swatch: swatch.getAttribute('data-swatch-value') || '#d8d8d8',
        image: swatch.getAttribute('data-image') || '',
        variantId: swatch.getAttribute('data-variant-id') || '',
        available: swatch.getAttribute('data-available') === 'true'
      };
    });
  }

  function familyEntry(card, handle) {
    return colorFamily(card).find(function (item) {
      return String(item.handle) === String(handle);
    }) || null;
  }

  function optionNames(product) {
    if (!product) return [];
    if (Array.isArray(product.options)) {
      return product.options.map(function (option, index) {
        if (typeof option === 'string') return option;
        return option && option.name ? option.name : ('Option ' + (index + 1));
      });
    }
    return [];
  }

  function uniqueOptionValues(product, index) {
    var values = [];
    (product.variants || []).forEach(function (variant) {
      var value = variant && variant.options ? variant.options[index] : null;
      if (value != null && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function needsVariantPicker(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return false;
    if (product.variants.length <= 1) return false;

    var names = optionNames(product);
    return names.some(function (name, index) {
      if (isColorOption(name)) return false;
      var normalized = String(name || '').trim().toLowerCase();
      if (normalized === '' || normalized === 'title') return false;
      return uniqueOptionValues(product, index).length > 1;
    });
  }

  function selectedValuesByName(product, selected) {
    var map = {};
    var names = optionNames(product);
    names.forEach(function (name, index) {
      if (isColorOption(name)) return;
      var key = String(name || '').trim().toLowerCase();
      if (!key || key === 'title') return;
      if (selected && selected[index] != null) map[key] = String(selected[index]);
    });
    return map;
  }

  function chooseVariantForProduct(product, preferredByName, preferredVariantId) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;

    if (preferredVariantId) {
      var byId = product.variants.find(function (variant) {
        return String(variant.id) === String(preferredVariantId) && variant.available;
      });
      if (byId) return byId;
    }

    var names = optionNames(product);
    var available = product.variants.filter(function (variant) { return variant && variant.available; });

    if (preferredByName && available.length) {
      var matched = available.find(function (variant) {
        return names.every(function (name, index) {
          if (isColorOption(name)) return true;
          var key = String(name || '').trim().toLowerCase();
          if (!key || key === 'title' || preferredByName[key] == null) return true;
          return String(variant.options[index]) === String(preferredByName[key]);
        });
      });
      if (matched) return matched;
    }

    return available[0] || product.variants[0] || null;
  }

  function isSizeOption(name) {
    var value = String(name || '').trim().toLowerCase();
    return value === 'size' || value === 'talla' || value === 'tamaño' || value === 'tamano' || value.indexOf('size') !== -1;
  }

  function isColorOption(name) {
    var value = String(name || '').trim().toLowerCase();
    return value === 'color' || value === 'colour' || value === 'color/colour' || value.indexOf('color') !== -1 || value.indexOf('colour') !== -1;
  }

  function displayOptionName(name) {
    return isSizeOption(name) ? 'Talla' : String(name || 'Option');
  }

  function getVariantImage(variant, product) {
    var image = variant && variant.featured_image;
    if (typeof image === 'string') return image;
    if (image && image.src) return image.src;
    image = product && product.featured_image;
    if (typeof image === 'string') return image;
    if (image && image.src) return image.src;
    if (product && Array.isArray(product.images) && product.images.length) {
      var first = product.images[0];
      return typeof first === 'string' ? first : (first && first.src ? first.src : '');
    }
    return '';
  }

  function formatVariantMoney(cents) {
    cents = Number(cents || 0);
    var money = moneyConfig();
    if (money.format && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, money.format); } catch (e) {}
    }
    /* AM MX 2026-10-12: apply the store money format ("$ {{amount}}") so cards match the product page ($ 1,999.00) */
    if (money.format && /\{\{\s*\w+\s*\}\}/.test(money.format)) {
      var fmt = function (n, d, ts, ds) {
        var parts = (n / 100).toFixed(d).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
        return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
      };
      return money.format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        if (key === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
        if (key === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
        if (key === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
        return fmt(cents, 2, ',', '.');
      });
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: money.currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function syncCardToProduct(card, handle, preferredVariant) {
    if (!card) return null;

    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-swatch]'));
    var swatch = swatches.find(function (item) {
      return String(item.getAttribute('data-product-handle') || '') === String(handle || '');
    });
    /* A product with a color name but no swatch value renders no swatch; keep it
       selected instead of jumping to the first sibling color. */
    if (!swatch && !handle) swatch = swatches[0] || null;

    var finalHandle = swatch ? (swatch.getAttribute('data-product-handle') || '') : String(handle || '');
    var product = parseProduct(card, finalHandle);
    if (!product) return null;

    var variant = preferredVariant || chooseVariantForProduct(
      product,
      null,
      swatch ? swatch.getAttribute('data-variant-id') : ''
    );

    card.dataset.selectedProductHandle = finalHandle;
    card.dataset.selectedColor = swatch ? (swatch.getAttribute('data-color') || '') : '';
    card.setAttribute('data-product-id', swatch ? (swatch.getAttribute('data-product-id') || product.id || '') : (product.id || ''));

    swatches.forEach(function (item) {
      item.classList.toggle('is-selected', item === swatch);
    });

    var productUrl = (swatch && swatch.getAttribute('data-product-url')) || product.url || '#';
    card.querySelectorAll('[data-product-card-link]').forEach(function (link) {
      link.setAttribute('href', productUrl);
    });

    var title = card.querySelector('[data-product-card-title]');
    if (title) title.textContent = product.title || '';

    var cartBtn = card.querySelector('[data-add-to-cart]');
    if (cartBtn) {
      cartBtn.setAttribute('data-product-id', product.id || '');
      cartBtn.setAttribute('data-product-handle', finalHandle);
      cartBtn.setAttribute('data-variant-id', variant ? variant.id : '');
    }

    var wishlistBtn = card.querySelector('[data-wishlist-toggle]');
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-product-id', product.id || '');
      wishlistBtn.setAttribute('data-product-handle', finalHandle);
    }

         var priceValue = variant ? variant.price : product.price;
    var compareValue = variant && Number(variant.compare_at_price || 0) > Number(variant.price || 0)
      ? Number(variant.compare_at_price || 0)
      : Number(product.compare_at_price || 0);
    var currentValue = Number(priceValue || 0);
    var onSale = compareValue > currentValue && compareValue > 0;
    var discountPercent = onSale
      ? Math.round(((compareValue - currentValue) / compareValue) * 100)
      : 0;
    var showBadge = discountPercent >= 5;
    var showSavings = discountPercent > 10;

    var priceEl = card.querySelector('[data-product-card-price]');
    var compareEl = card.querySelector('[data-product-card-compare]');
    var savingsEl = card.querySelector('[data-product-card-savings]');
    var badgeEl = card.querySelector('[data-product-card-badge]');

    if (priceEl) priceEl.textContent = formatVariantMoney(currentValue);
    if (compareEl) {
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale ? formatVariantMoney(compareValue) : '';
    }
    if (savingsEl) {
      savingsEl.hidden = !showSavings;
      savingsEl.textContent = showSavings ? ('Ahorra ' + formatVariantMoney(compareValue - currentValue)) : '';
    }
    if (badgeEl) {
      badgeEl.hidden = !showBadge;
      badgeEl.textContent = showBadge ? (discountPercent + '% off') : '';
    }

    var imageUrl = getVariantImage(variant, product) || (swatch && swatch.getAttribute('data-image')) || '';
    var slides = Array.prototype.slice.call(card.querySelectorAll('[data-slide]'));
    if (imageUrl && slides.length) {
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === 0);
      });
      var first = slides[0];
      first.src = imageUrl;
      first.srcset = '';
      first.alt = product.title || '';
      card.querySelectorAll('[data-slider-segment]').forEach(function (segment, index) {
        segment.classList.toggle('is-active', index === 0);
      });
    }

    card.dispatchEvent(new CustomEvent('product-card:selection-changed', {
      detail: { product: product, variant: variant, handle: finalHandle }
    }));

    return { product: product, variant: variant, swatch: swatch };
  }

  function findExactVariant(product, selected) {
    return (product.variants || []).find(function (variant) {
      if (!variant || !Array.isArray(variant.options)) return false;
      return variant.options.every(function (value, index) {
        return String(value) === String(selected[index]);
      });
    }) || null;
  }

  function optionValueCanSell(product, optionIndex, candidate, selected) {
    return (product.variants || []).some(function (variant) {
      if (!variant || !variant.available || !Array.isArray(variant.options)) return false;
      if (String(variant.options[optionIndex]) !== String(candidate)) return false;
      return variant.options.every(function (value, index) {
        if (index === optionIndex) return true;
        if (selected[index] == null || selected[index] === '') return true;
        return String(value) === String(selected[index]);
      });
    });
  }

  function escapePickerHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function isVariantPickerOpen() {
    return !!(variantPicker && variantPicker.classList.contains('is-open'));
  }

  function getPickerPanelFromEvent(event) {
    var target = event && event.target;
    if (!(target instanceof Element)) return null;
    return target.closest('.pcvp__panel');
  }

  function pickerPanelCanScroll(panel, deltaY) {
    if (!panel || !deltaY) return false;
    var maxScroll = Math.max(0, panel.scrollHeight - panel.clientHeight);
    if (maxScroll <= 1) return false;
    if (deltaY < 0) return panel.scrollTop > 0;
    return panel.scrollTop < maxScroll - 1;
  }

  function containPickerWheel(event) {
    if (!isVariantPickerOpen()) return;

    var panel = getPickerPanelFromEvent(event);

    /*
      Always stop the wheel event from bubbling to document/window where
      sticky-header runtimes may treat it as page-scroll direction.
      We do NOT preventDefault while the picker panel can still scroll.
    */
    event.stopPropagation();

    if (!panel || !pickerPanelCanScroll(panel, Number(event.deltaY || 0))) {
      if (event.cancelable) event.preventDefault();
    }
  }

  function rememberPickerTouch(event) {
    if (!isVariantPickerOpen() || !event.touches || !event.touches.length) return;
    pcvpTouchY = event.touches[0].clientY;
    event.stopPropagation();
  }

  function containPickerTouch(event) {
    if (!isVariantPickerOpen() || !event.touches || !event.touches.length) return;

    var currentY = event.touches[0].clientY;
    var deltaY = pcvpTouchY == null ? 0 : pcvpTouchY - currentY;
    pcvpTouchY = currentY;
    var panel = getPickerPanelFromEvent(event);

    event.stopPropagation();

    /* Block only the movement that would escape the drawer at its edges. */
    if (!panel || (deltaY && !pickerPanelCanScroll(panel, deltaY))) {
      if (event.cancelable) event.preventDefault();
    }
  }

  function clearPickerTouch(event) {
    pcvpTouchY = null;
    if (isVariantPickerOpen() && event) event.stopPropagation();
  }

  function lockSharedAntonyOverlay() {
    var lock = window.AntonyOverlayLock;
    if (!lock || typeof lock.lock !== 'function') return;
    if (pcvpSharedOverlayLocked) return;
    lock.lock(PCVP_OVERLAY_TOKEN);
    pcvpSharedOverlayLocked = true;
  }

  function unlockSharedAntonyOverlay() {
    var lock = window.AntonyOverlayLock;
    if (!pcvpSharedOverlayLocked) return;
    pcvpSharedOverlayLocked = false;
    if (lock && typeof lock.unlock === 'function') {
      lock.unlock(PCVP_OVERLAY_TOKEN);
    }
  }

  function ensureVariantPicker() {
    if (variantPicker && document.body.contains(variantPicker)) return variantPicker;

    variantPicker = document.createElement('div');
    variantPicker.className = 'pcvp';
    variantPicker.setAttribute('aria-hidden', 'true');
    variantPicker.innerHTML = [
      '<div class="pcvp__backdrop" data-pcvp-close></div>',
      '<section class="pcvp__panel" role="dialog" aria-modal="false" aria-label="Elige tu talla">',
        '<button class="pcvp__close" type="button" aria-label="Cerrar" data-pcvp-close></button>',
        '<div class="pcvp__options" data-pcvp-options></div>',
        '<div class="pcvp__product">',
          '<div class="pcvp__image-wrap"><img class="pcvp__image" data-pcvp-image alt=""></div>',
          '<div class="pcvp__title" data-pcvp-title></div>',
          '<div class="pcvp__price" data-pcvp-price></div>',
          '<button class="pcvp__add" type="button" data-pcvp-add disabled>Elige tu talla</button>',
          '<div class="pcvp__message" data-pcvp-message aria-live="polite"></div>',
        '</div>',
      '</section>'
    ].join('');

    document.body.appendChild(variantPicker);

    /*
      Isolate the drawer's own input stream from the page/header.
      Internal scrolling still works; edge overscroll/background scroll does not.
    */
    variantPicker.addEventListener('wheel', containPickerWheel, { passive: false });
    variantPicker.addEventListener('touchstart', rememberPickerTouch, { passive: true });
    variantPicker.addEventListener('touchmove', containPickerTouch, { passive: false });
    variantPicker.addEventListener('touchend', clearPickerTouch, { passive: true });
    variantPicker.addEventListener('touchcancel', clearPickerTouch, { passive: true });

    variantPicker.addEventListener('transitionend', function (event) {
      if (event.target !== variantPicker && event.target !== variantPicker.querySelector('.pcvp__panel')) return;
      if (!variantPicker.classList.contains('is-open')) {
        var panel = variantPicker.querySelector('.pcvp__panel');
        if (panel) panel.setAttribute('aria-modal', 'false');
        variantPicker.setAttribute('aria-hidden', 'true');
        variantPicker.setAttribute('inert', '');
      }
    });

    variantPicker.addEventListener('click', function (event) {
      var close = event.target.closest('[data-pcvp-close]');
      if (close) {
        event.preventDefault();
        closeVariantPicker();
        return;
      }

      var colorProductButton = event.target.closest('[data-pcvp-product-color]');
      if (colorProductButton && !colorProductButton.disabled) {
        event.preventDefault();

        var nextHandle = colorProductButton.getAttribute('data-product-handle') || '';
        var nextProduct = parseProduct(pickerState.card, nextHandle);
        if (!nextProduct) return;

        var preferred = selectedValuesByName(pickerState.product, pickerState.selected);
        var nextVariant = chooseVariantForProduct(nextProduct, preferred, '');

        pickerState.product = nextProduct;
        pickerState.colorHandle = nextHandle;
        pickerState.variant = nextVariant;
        pickerState.selected = nextVariant && Array.isArray(nextVariant.options) ? nextVariant.options.slice() : [];

        syncCardToProduct(pickerState.card, nextHandle, nextVariant);
        renderVariantPicker();
        return;
      }

      var valueButton = event.target.closest('[data-pcvp-value]');
      if (valueButton && !valueButton.disabled) {
        event.preventDefault();
        var index = Number(valueButton.getAttribute('data-option-index'));
        pickerState.selected[index] = valueButton.getAttribute('data-option-value');
        pickerState.variant = findExactVariant(pickerState.product, pickerState.selected);
        renderVariantPicker();
        return;
      }

      var addButton = event.target.closest('[data-pcvp-add]');
      if (addButton && !addButton.disabled) {
        event.preventDefault();
        var variant = pickerState.variant;
        if (!variant || !variant.available) return;
        addButton.disabled = true;
        addButton.textContent = 'Agregando…';
        addVariantToCart(variant.id)
          .then(function () {
            closeVariantPicker();
          })
          .catch(function (error) {
            var msg = variantPicker.querySelector('[data-pcvp-message]');
            if (msg) msg.textContent = error.message || 'No se pudo agregar al carrito';
            addButton.disabled = false;
            addButton.textContent = 'Agregar al carrito';
          });
        return;
      }

    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && variantPicker && variantPicker.classList.contains('is-open')) {
        closeVariantPicker();
      }
    });

    return variantPicker;
  }

  function openVariantPicker(card, product) {
    var picker = ensureVariantPicker();
    var cartButton = card.querySelector('[data-add-to-cart]');
    var panel = picker.querySelector('.pcvp__panel');
    var selectedHandle = card.dataset.selectedProductHandle || card.dataset.productHandle || '';
    product = parseProduct(card, selectedHandle) || product;
    var currentVariantId = cartButton ? String(cartButton.getAttribute('data-variant-id') || '') : '';

    pcvpReturnFocus = cartButton || document.activeElement;
    picker.removeAttribute('inert');
    if (panel) panel.setAttribute('aria-modal', 'true');

    var initialVariant = chooseVariantForProduct(product, null, currentVariantId);

    pickerState.card = card;
    pickerState.product = product;
    pickerState.colorHandle = selectedHandle || (product && product.handle) || '';
    pickerState.variant = initialVariant || null;
    pickerState.selected = initialVariant && Array.isArray(initialVariant.options) ? initialVariant.options.slice() : [];

    renderVariantPicker();
    picker.setAttribute('aria-hidden', 'false');

    /*
      Use the header's shared overlay lock when present. It snapshots the page,
      blocks escaped viewport scrolling, and freezes the sticky/autohide header.
      pcvp-lock remains as a self-contained fallback for older header versions.
    */
    lockSharedAntonyOverlay();
    document.documentElement.classList.add('pcvp-lock');

    // Force the hidden/off-screen state to paint first, then slide the drawer up.
    picker.classList.remove('is-open');
    void picker.offsetHeight;
    window.requestAnimationFrame(function () {
      picker.classList.add('is-open');
    });

    window.setTimeout(function () {
      var first = picker.querySelector('[data-pcvp-product-color].is-selected') || picker.querySelector('[data-pcvp-value].is-selected') || picker.querySelector('[data-pcvp-product-color]:not(:disabled)') || picker.querySelector('[data-pcvp-value]:not(:disabled)') || picker.querySelector('[data-pcvp-close]');
      if (first) first.focus({ preventScroll: true });
    }, 380);
  }

  function closeVariantPicker() {
    if (!variantPicker) return;

    var panel = variantPicker.querySelector('.pcvp__panel');
    var active = document.activeElement;
    var returnFocus = pcvpReturnFocus;

    /*
      IMPORTANT ORDER:
      1. Move focus out of the dialog.
      2. Remove aria-modal=true immediately.
      3. Then begin the visual closing transition.
      This prevents AntonyOverlayLock's global dialog observer from keeping
      the page locked after the drawer has visually closed.
    */
    if (active instanceof HTMLElement && variantPicker.contains(active)) {
      try { active.blur(); } catch (e) {}
    }

    if (panel) panel.setAttribute('aria-modal', 'false');
    variantPicker.setAttribute('inert', '');
    variantPicker.setAttribute('aria-hidden', 'true');
    variantPicker.classList.remove('is-open');

    document.documentElement.classList.remove('pcvp-lock');
    unlockSharedAntonyOverlay();

    pcvpTouchY = null;
    pickerState.card = null;
    pickerState.product = null;
    pickerState.selected = [];
    pickerState.variant = null;
    pickerState.colorHandle = '';
    pcvpReturnFocus = null;

    /*
      Restore focus only after the overlay lock has been released.
      preventScroll keeps the underlying page exactly where it was.
    */
    window.requestAnimationFrame(function () {
      if (returnFocus instanceof HTMLElement && document.contains(returnFocus)) {
        try { returnFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    });
  }

  function renderVariantPicker() {
    if (!variantPicker || !pickerState.product) return;
    var product = pickerState.product;
    var names = optionNames(product);
    var optionsHost = variantPicker.querySelector('[data-pcvp-options]');
    var image = variantPicker.querySelector('[data-pcvp-image]');
    var title = variantPicker.querySelector('[data-pcvp-title]');
    var price = variantPicker.querySelector('[data-pcvp-price]');
    var add = variantPicker.querySelector('[data-pcvp-add]');
    var message = variantPicker.querySelector('[data-pcvp-message]');

    /*
      COLOR is NOT generated from product.variants.
      The color row comes from the card's current product +
      custom.complete_the_look_color_swatch.
      Each button switches pickerState.product to that related Shopify product.
    */
    var family = colorFamily(pickerState.card);
    var colorGroup = '';
    if (family.length) {
      var colorButtons = family.map(function (item) {
        var selectedColor = String(item.handle) === String(pickerState.colorHandle || product.handle || '');
        var classes = 'pcvp__value pcvp__value--color' + (selectedColor ? ' is-selected' : '');
        var label = item.color || item.handle || 'Color';
        var swatchValue = item.swatch || '#d8d8d8';

        return '<button type="button" class="' + classes + '"' +
          ' data-pcvp-product-color' +
          ' data-product-handle="' + escapePickerHtml(item.handle) + '"' +
          ' title="' + escapePickerHtml(label) + (item.available ? '' : ' - Agotado') + '"' +
          ' aria-label="' + escapePickerHtml(label) + (item.available ? '' : ', agotado') + '"' +
          (item.available ? '' : ' disabled') +
          '><span class="pcvp__color-dot" style="--pcvp-swatch:' + escapePickerHtml(swatchValue) + '"></span></button>';
      }).join('');

      colorGroup = '<div class="pcvp__group"><div class="pcvp__label">Color</div><div class="pcvp__values">' + colorButtons + '</div></div>';
    }

    /*
      Internal Color/Colour options are intentionally hidden here. They are only
      used internally to resolve a variant if the merchant still has one on the
      individual product. Size and other real variant options stay selectable.
    */
    var variantGroups = names.map(function (name, optionIndex) {
      if (isColorOption(name)) return '';

      var normalizedName = String(name || '').trim().toLowerCase();
      if (!normalizedName || normalizedName === 'title') return '';

      var values = uniqueOptionValues(product, optionIndex);
      var buttons = values.map(function (value) {
        var selected = String(pickerState.selected[optionIndex]) === String(value);
        var canSell = optionValueCanSell(product, optionIndex, value, pickerState.selected);
        var classes = 'pcvp__value' + (selected ? ' is-selected' : '');

        return '<button type="button" class="' + classes + '"' +
          ' data-pcvp-value data-option-index="' + optionIndex + '"' +
          ' data-option-value="' + escapePickerHtml(value) + '"' +
          (canSell ? '' : ' disabled') +
          '>' + escapePickerHtml(value) + '</button>';
      }).join('');

      return '<div class="pcvp__group"><div class="pcvp__label">' +
        escapePickerHtml(displayOptionName(name)) +
        '</div><div class="pcvp__values">' + buttons + '</div></div>';
    }).join('');

    optionsHost.innerHTML = colorGroup + variantGroups;

    var exact = findExactVariant(product, pickerState.selected);
    pickerState.variant = exact;
    var previewVariant = exact || chooseVariantForProduct(product, selectedValuesByName(product, pickerState.selected), '') || null;
    var imageUrl = getVariantImage(previewVariant, product);

    if (image) {
      image.src = imageUrl || '';
      image.alt = product.title || '';
      image.style.visibility = imageUrl ? 'visible' : 'hidden';
    }
    if (title) title.textContent = product.title || '';
    if (price) price.textContent = previewVariant ? formatVariantMoney(previewVariant.price) : '';
    if (message) message.textContent = exact && !exact.available ? 'Agotado' : '';

    if (pickerState.card && exact) {
      var cartBtn = pickerState.card.querySelector('[data-add-to-cart]');
      if (cartBtn) cartBtn.setAttribute('data-variant-id', exact.id || '');
    }

    if (add) {
      var canAdd = !!(exact && exact.available);
      add.disabled = !canAdd;
      add.textContent = canAdd ? 'Agregar al carrito' : (exact ? 'Agotado' : 'Elige tu talla');
    }
  }

  function addVariantToCart(variantId) {
    if (!variantId) return Promise.reject(new Error('Este producto no está disponible'));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (err) {
            throw new Error(err.description || err.message || 'No se pudo agregar al carrito');
          });
        }
        return response.json();
      })
      .then(function (payload) {
        showToast('Agregado al carrito');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));
        document.dispatchEvent(new CustomEvent('antony:cart:updated', { detail: payload }));
        return payload;
      });
  }


  /* ---------------- wishlist storage helpers ---------------- */

  function getWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { ids: ids } })
    );
  }

  function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWishlist(productId) {
    productId = String(productId);
    var ids = getWishlist();
    var index = ids.indexOf(productId);
    var added;

    if (index === -1) {
      ids.push(productId);
      added = true;
    } else {
      ids.splice(index, 1);
      added = false;
    }

    saveWishlist(ids);
    return added;
  }

  /* ---------------- toast ---------------- */

  function showToast(message) {
    var toast = document.querySelector('.product-card-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'product-card-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimeout);
    toast._hideTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1800);
  }

  /* ---------------- slider ---------------- */

  function initSlider(card) {
    var slider = card.querySelector('[data-slider]');
    if (!slider) return;

    var slides = Array.prototype.slice.call(card.querySelectorAll('[data-slide]'));
    var segments = Array.prototype.slice.call(card.querySelectorAll('[data-slider-segment]'));
    var prevBtn = card.querySelector('[data-slider-prev]');
    var nextBtn = card.querySelector('[data-slider-next]');

    if (slides.length < 2) return;

    var current = 0;

    function render() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      segments.forEach(function (segment, i) {
        segment.classList.toggle('is-active', i === current);
      });
    }

    function go(delta) {
      current = (current + delta + slides.length) % slides.length;
      render();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(1);
      });
    }
  }

  /* ---------------- add to cart ---------------- */

  function initAddToCart(card) {
    var btn = card.querySelector('[data-add-to-cart]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-loading')) return;

      var product = selectedProduct(card);
      if (product && needsVariantPicker(product)) {
        openVariantPicker(card, product);
        return;
      }

      var variantId = btn.getAttribute('data-variant-id');
      var directVariant = product && Array.isArray(product.variants)
        ? product.variants.find(function (variant) { return String(variant.id) === String(variantId) && variant.available; })
        : null;

      if (!variantId || variantId === '' || (product && !directVariant)) {
        showToast('Este producto no está disponible');
        return;
      }

      btn.classList.add('is-loading');
      addVariantToCart(variantId)
        .catch(function (error) {
          showToast(error.message || 'No se pudo agregar al carrito');
        })
        .finally(function () {
          btn.classList.remove('is-loading');
        });
    });
  }

  /* ---------------- wishlist button ---------------- */

  function initWishlistButton(card) {
    var btn = card.querySelector('[data-wishlist-toggle]');
    if (!btn) return;

    function currentProductId() {
      return btn.getAttribute('data-product-id') || card.getAttribute('data-product-id') || '';
    }

    function reflectState() {
      var active = isWishlisted(currentProductId());
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    reflectState();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var productId = currentProductId();
      if (!productId) return;
      var added = toggleWishlist(productId);
      reflectState();
      showToast(added ? 'Agregado a favoritos' : 'Eliminado de favoritos');
    });

    document.addEventListener('wishlist:updated', reflectState);
    card.addEventListener('product-card:selection-changed', reflectState);
  }

  /* ---------------- color swatches ---------------- */

  function initSwatches(card) {
    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-swatch]'));
    if (!swatches.length) return;

    /*
      The first/current product is selected on initial render.
      Clicking another swatch selects THAT related product, not a variant color
      inside the original product.
    */
    syncCardToProduct(card, card.dataset.selectedProductHandle || card.dataset.productHandle);

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (swatch.disabled) return;

        var handle = swatch.getAttribute('data-product-handle') || '';
        syncCardToProduct(card, handle);
      });
    });
  }

  /* ---------------- init all cards on the page ---------------- */

  function initCard(card) {
    if (card._productCardInit) return;
    card._productCardInit = true;
    initSlider(card);
    initAddToCart(card);
    initWishlistButton(card);
    initSwatches(card);
  }

  function initAll(root) {
    var scope = root || document;
    Array.prototype.slice
      .call(scope.querySelectorAll('[data-product-card]'))
      .forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('product-cards:refresh', function (e) {
    initAll((e && e.detail && e.detail.root) || document);
  });
})();